<template>
    <div>
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <div class="load" v-loading="loading"></div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    // import MainTabBar from "../../components/content/maintabber/MainTabBar";
    export default {
        data(){
            return{
                loading:true
            }
        },
        // components: {
        //     MainTabBar,
        // },
        mounted() {
            console.log(this.$route.query.routerUrl)
            this.$router.push(this.$route.query.routerUrl)
        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>
<style scoped>
.load{
    margin-top: 40vh;
}
</style>
